import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";
import Mark3D from "@/components/Mark3D";

export default function LoadingScreen({ onComplete }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const controls = animate(0, 100, {
            duration: 1.2,
            ease: [0.3, 0.7, 0.4, 1],
            onUpdate: (v) => setProgress(v),
        });
        return () => controls.stop();
    }, []);

    useEffect(() => {
        if (progress >= 100) {
            const t = setTimeout(onComplete, 250);
            return () => clearTimeout(t);
        }
    }, [progress, onComplete]);

    return (
        <motion.div
            data-testid="loading-screen"
            className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-coal"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
            <div className="blueprint-grid absolute inset-0 opacity-60" />
            <motion.div
                data-testid="loader-mark"
                className="h-[240px] w-[320px] sm:h-[280px] sm:w-[400px]"
                initial={{ opacity: 0, scale: 0.85 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
                <Mark3D />
            </motion.div>
            <div className="absolute bottom-10 left-0 right-0 px-8 sm:px-14">
                <div className="flex items-end justify-between">
                    <p className="text-[10px] uppercase tracking-[0.4em] text-ash">
                        Composing the experience
                    </p>
                    <p
                        data-testid="loading-progress"
                        className="font-display text-5xl font-light text-white/80"
                    >
                        {Math.round(progress)}
                        <span className="text-gold">%</span>
                    </p>
                </div>
                <div className="mt-4 h-px w-full bg-white/10">
                    <div
                        className="h-px bg-gold transition-[width] duration-100 ease-linear"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
        </motion.div>
    );
}
